module.exports = __webpack_public_path__ + "media/img/private-venue/work-aee7bdb5646d82849a641d683eae8c4c.svg";